<template>
  <addOrganization :organization="organization" />
</template>
<script>
import addOrganization from './add'
import { getAOrganization } from '@/api/acl'

export default {
  data() {
    return {
      organization: null,
      loading: true,
    }
  },
  components: {
    addOrganization,
  },
  created() {
    getAOrganization.api(this.$route.params.id).then((res) => {
      this.organization = {
        ...res,
        id: this.$route.params.id,
        disabled: this.$route.name.includes('VIEW') ? true : false,
        parent: res.parent.id,
        users: res.users.map(i => i.id)
      }
      this.loading = false
    })
  },
}
</script>
